var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    fill: "#EBF0F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    stroke: "#C2CCD0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3891_48533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5583 22.8995C28.2815 22.5793 27.908 22.3693 27.5 22.289V21.875C27.5 20.0142 25.9858 18.5 24.125 18.5C22.2642 18.5 20.75 20.0142 20.75 21.875V22.289C20.342 22.3693 19.9685 22.5793 19.6917 22.8995C19.3355 23.312 19.1765 23.858 19.2552 24.3973L19.6483 27.077C19.8095 28.1735 20.7665 29 21.8742 29H26.3743C27.482 29 28.439 28.1735 28.6003 27.077L28.9932 24.3973C29.072 23.858 28.9137 23.312 28.5568 22.8995H28.5583ZM24.125 20C25.1585 20 26 20.8415 26 21.875V22.25H22.25V21.875C22.25 20.8415 23.0915 20 24.125 20ZM27.1175 26.8588C27.0635 27.224 26.7448 27.5 26.375 27.5H21.875C21.5052 27.5 21.1865 27.224 21.1325 26.8595L20.7395 24.1798C20.7177 24.032 20.7852 23.9285 20.8272 23.8798C20.8692 23.8317 20.9615 23.75 21.1108 23.75H27.14C27.2892 23.75 27.3815 23.831 27.4235 23.8798C27.4655 23.9285 27.533 24.032 27.5112 24.1798L27.1175 26.8588ZM14 14.375C14 13.754 14.504 13.25 15.125 13.25C15.746 13.25 16.25 13.754 16.25 14.375C16.25 14.996 15.746 15.5 15.125 15.5C14.504 15.5 14 14.996 14 14.375ZM17 14.375C17 13.754 17.504 13.25 18.125 13.25C18.746 13.25 19.25 13.754 19.25 14.375C19.25 14.996 18.746 15.5 18.125 15.5C17.504 15.5 17 14.996 17 14.375ZM17 26H14.75C13.5095 26 12.5 24.9905 12.5 23.75V17.75H27.5V18.5C27.5 18.914 27.836 19.25 28.25 19.25C28.664 19.25 29 18.914 29 18.5V14.75C29 12.6823 27.3177 11 25.25 11H14.75C12.6823 11 11 12.6823 11 14.75V23.75C11 25.8177 12.6823 27.5 14.75 27.5H17C17.414 27.5 17.75 27.164 17.75 26.75C17.75 26.336 17.414 26 17 26ZM14.75 12.5H25.25C26.4905 12.5 27.5 13.5095 27.5 14.75V16.25H12.5V14.75C12.5 13.5095 13.5095 12.5 14.75 12.5Z",
    fill: "#00507C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3891_48533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit_card.5e4df2f52b749b098c30d1f4d9405c9a.svg";
export { ForwardRef as ReactComponent };